import { Box, Heading, VStack, Text,Image,SimpleGrid,useColorModeValue , useBreakpointValue,useToast} from '@chakra-ui/react';
import PublicLayout from "./Layouts/PublicLayout";
import { useNavigate } from "react-router-dom";
import { useState,useCallback,  } from "react";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom'; 
import {  OfferDetails } from '../../Platform/Common/types';
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  Button,
  Divider,
} from "@chakra-ui/react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import bandpic from "../../resources/EDUVIC B2C Hero3.png";


const B2COfferPage = () => {

 const { domainSlug } = useParams<{ domainSlug?: string }>();
 const { offerSlug } = useParams<{ offerSlug?: string }>();

  const navigate = useNavigate();
  const [hover, setHover] = useState(false);
  const handleNavigation = (path: string) => {
    navigate(path);
  };

  const theme = useColorModeValue("light", "dark");
  const isMobile = useBreakpointValue({ base: true, md: false });

    const currencySymbol =
  process.env.REACT_APP_PLATFORM_CURRENCY_SYMBOL || "$";

   const [offerDetails, setOfferDetails] = useState<OfferDetails>();
  
    const toast = useToast();
    const tableHeaderbg = useColorModeValue("gray.200", "gray.700");
  
    useEffect(() => {
      let cancelled = false;

      const fetchOfferDetails = async () => {
        if (!domainSlug || !offerSlug) return;
        try {
          const apiUrl = process.env.REACT_APP_API_URL || 'https://default-url.com';
          const response = await axios.get(`${apiUrl}/b2c/public/domain/${domainSlug}/offer/${offerSlug}`);
          if (!cancelled) setOfferDetails(response.data);
        } catch (error) {
          if (!cancelled) console.error("Failed to load B2C Offer", error);
        }
      };

      fetchOfferDetails();
      return () => { cancelled = true; };
    }, [offerSlug, domainSlug]);

  

  const offerBg = useColorModeValue("blue.100", "gray.800");

const { hash, pathname } = useLocation();

useEffect(() => {
  if (hash) {
    const element = document.querySelector(hash);
    if (element) {
      const yOffset = -80;
      const yPosition =
        element.getBoundingClientRect().top +
        window.scrollY +
        yOffset;

      window.scrollTo({ top: yPosition, behavior: "smooth" });
      return;
    }
  }

  // If no hash → reset to top
  window.scrollTo(0, 0);

}, [pathname, hash]);


const getThemeColors = (theme: string) => {
  const base = theme.toLowerCase();
  return {
    badgeBgLight: `${base}.200`,
    badgeBgDark: `${base}.700`,
    badgeTextLight: `${base}.800`,
    badgeTextDark: `white`,
    borderLight: `${base}.300`,
    borderDark: `${base}.500`,
    accentLight: `${base}.50`,
    accentDark: `${base}.900`,
  };
};


// ===== SAFE THEME RESOLUTION =====
const resolvedTheme = (offerDetails?.theme_key || "BLUE").toLowerCase();
const resolvedBadgeTheme = (offerDetails?.badge_theme || "gray").toLowerCase();

// Hero styling
const heroBg = useColorModeValue(`${resolvedTheme}.50`, `${resolvedTheme}.900`);
const heroTextColor = useColorModeValue("gray.800", "white");

// Badge
const badgeBg = useColorModeValue(`${resolvedBadgeTheme}.200`, `${resolvedBadgeTheme}.700`);
const badgeText = useColorModeValue(`${resolvedBadgeTheme}.800`, "white");

// Borders / surfaces
const borderColor = useColorModeValue(`${resolvedTheme}.300`, `${resolvedTheme}.500`);
const cardBg = useColorModeValue("white", "gray.800");
const subtleBg = useColorModeValue("gray.50", "gray.900");
const durationBg = useColorModeValue("gray.100", "gray.700");

// Tier flags
const isHero = offerDetails?.promotion_tier === "HERO";
const isFeatured = offerDetails?.promotion_tier === "FEATURED";

// =========================
// HERO OVERLAY
// =========================

const heroOverlay = useColorModeValue(
  `linear(to-r,
    rgba(255,255,255,0.88),
    rgba(255,255,255,0.72)
  )`,
  `linear(to-r,
    rgba(17,24,39,0.82),
    rgba(17,24,39,0.72)
  )`
);

// Theme tint layer
const heroThemeTint = useColorModeValue(
  `${resolvedTheme}.50`,
  `${resolvedTheme}.900`
);

return (
  <PublicLayout>
    <Box bg={subtleBg} minH="80vh">

{/* ================= HERO ================= */}

      <Box
        as="section"
        minH={{ base: "260px", md: "320px" }}
        bgImage={bandpic}
        bgSize="cover"
        // Mobile crops from the left side of the source image instead of
        // the right, so the logo/figure moves out of the text's way.
        // Desktop/tablet unchanged.
        bgPosition={{ base: "left center", md: "right center" }}
        bgRepeat="no-repeat"
        position="relative"
        overflow="hidden"
      >
  {/* LEFT Gradient Overlay for readability */}
  <Box
    position="absolute"
    top="0"
    left="0"
    width="100%"
    height="100%"
    bgGradient="
      linear(
        to-r,
        rgba(0,0,0,0.68),
        rgba(0,0,0,0.35),
        rgba(0,0,0,0)
      )
    "
    zIndex={1}
  />

  {/* Content */}
  <Box
    position="relative"
    zIndex={2}
    minH={{ base: "260px", md: "320px" }}
    display="flex"
    alignItems="center"
    px={{ base: 6, md: 16 }}
  >
    <VStack
      align="flex-start"
      spacing={4}
      maxW="700px"
    >

      {offerDetails?.badge_text && (
        <Box
          bg={badgeBg}
          color={badgeText}
          px={4}
          py={1}
          borderRadius="full"
          fontSize="sm"
          fontWeight="semibold"
          boxShadow="sm"
        >
          {offerDetails.badge_text}
        </Box>
      )}

      <Heading
        color="white"
        size="2xl"
        lineHeight="1.2"
      >
        {offerDetails?.name}
      </Heading>

      {offerDetails?.duration_label && (
        <Text
          color="gray.100"
          fontSize={{ base: "md", md: "lg" }}
          lineHeight="1.6"
        >
          {offerDetails.duration_label}
        </Text>
      )}

    </VStack>
  </Box>
</Box>
      {/* ================= MAIN ================= */}
      <Box py={4} px={6}>
        <SimpleGrid
          columns={{ base: 1, md: 3 }}
          spacing={6}
          maxW="1200px"
          mx="auto"
        >

          {/* ===== LEFT (2/3) ===== */}
          <Box gridColumn={{ md: "span 2" }}>

            {offerDetails?.long_description && (
            <Box
              bg={cardBg}
              rounded="2xl"
              border="1px solid"
              borderColor={borderColor}
              overflow="hidden"
            >

              <Box
                height="6px"
                bg={`${resolvedTheme}.500`}
              />         

                <Box p={6} fontSize="md" lineHeight="1.8">
                  <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    components={{
                      h1: (props) => <Heading size="xl" mt={6} mb={4} {...props} />,
                      h2: (props) => <Heading size="lg" mt={6} mb={3} {...props} />,
                      p: (props) => <Text mb={4} {...props} />,
                      ul: (props) => <Box as="ul" pl={6} mb={4} {...props} />,
                      li: (props) => <Box as="li" mb={2} {...props} />,
                      strong: (props) => <Text as="span" fontWeight="bold" {...props} />,
                    }}
                  >
                    {offerDetails.long_description}
                  </ReactMarkdown>
                </Box>

              </Box>
            )}

          </Box>


          {/* ===== RIGHT (1/3) ===== */}
          <Box
            position={{ md: "sticky" }}
            top="100px"
            height="fit-content"
          >
 
            <Box
              bg={cardBg}
              border="2px solid"
              borderColor={borderColor}
              rounded="2xl"
              overflow="hidden"
              shadow={isHero ? "2xl" : "lg"}
            >
               <Box
                height="6px"
                bg={`${resolvedTheme}.500`}
              />   

              <VStack p={6} align="start" spacing={4}>

                <Heading size="md">
                  {offerDetails?.name}
                </Heading>

                {offerDetails?.duration_label && (
                  <Box
                    px={3}
                    py={1}
                    borderRadius="full"
                    bg={durationBg}
                    fontSize="sm"
                  >
                    {offerDetails.duration_label}
                  </Box>
                )}

                <Divider />

                <Heading size="lg">
                  {currencySymbol} {offerDetails?.total_price}
                </Heading>

                <Button
                  w="100%"
                  size="lg"
                  colorScheme={resolvedTheme}
                  onClick={() => navigate(`/practice/${domainSlug}/${offerSlug}/checkout`)}
                >
                  Buy Now
                </Button>

                <Button
                  variant="ghost"
                  w="100%"
                  onClick={() => navigate(`/practice/${domainSlug}`)}
                >
                  ← Back to Domain
                </Button>

              </VStack>

            </Box>
          </Box>

        </SimpleGrid>
      </Box>

    </Box>
  </PublicLayout>
);

}

export default B2COfferPage;